"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatTime = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var FormatTime = function (props) {
    if (!props.timestamp) {
        return null;
    }
    var attributes = {
        className: 'honeycomb-time',
    };
    var hour = 0;
    var minute = 0;
    var meridiem = 'am';
    if (props.useLocalTimezone) {
        // Create a date object to convert to the user's timezone
        var date = new Date(props.timestamp);
        hour = date.getHours();
        minute = date.getMinutes();
        attributes['data-offset'] = date.getTimezoneOffset();
    }
    else {
        // Create date in the timezone provided by the server
        var matches = props.timestamp.match(/^(?:\d{4,4}-\d{2,2}-\d{2,2}T)?(\d{2,2}):(\d{2,2})(?:\d{2,2})?/);
        if (!matches) {
            return null;
        }
        hour = parseInt(matches[1], 10);
        minute = parseInt(matches[2], 10);
    }
    if (hour >= 12) {
        meridiem = 'pm';
    }
    if (hour === 0) {
        hour = 12;
    }
    else if (hour > 12) {
        hour -= 12;
    }
    var humanreadable = hour + ":" + (minute < 10 ? '0' : '') + minute + " " + meridiem;
    return (React.createElement("span", __assign({}, attributes), humanreadable));
};
exports.FormatTime = FormatTime;
exports.FormatTime.defaultValue = {
    useLocalTimezone: false,
};
exports.FormatTime.propTypes = {
    format: function (props) {
        // Accepted formats:
        //   yyyy-MM-ddTHH:mm
        //   yyyy-MM-ddTHH:mm:ss
        //   yyyy-MM-ddTHH:mm:ss.fffffffzzz
        //   HH:mm
        //   HH:mm:ss
        if (props.timestamp && !props.timestamp.match(/^(?:\d{4,4}-\d{2,2}-\d{2,2}T)?(\d{2,2}:\d{2,2})(?:\d{2,2})?/)) {
            return new Error('The timestamp format should be yyyy-MM-ddTHH:mm');
        }
        return;
    },
    timestamp: PropTypes.string.isRequired,
    useLocalTimezone: PropTypes.bool,
};
